import { IFormRegister } from 'routes/Main/type';

import Form from 'components/Form';
import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';
import RowContentPreWrap from './components/RowContent';

interface Props extends IFormRegister {
  disabled?: boolean;
}

const Signature = (props: Props) => {
  const { disabled, register } = props;

  const labels = [
    { title: 'Ngày', variable: 'date' },
    { title: 'Quan hệ với bệnh nhân', variable: 'relationship' },
    {
      title: 'Tên của người đại diện chính\n(hoặc người đại diện pháp lý)',
      variable: 'name',
    },
    {
      title: 'Ký tên của bạn (hoặc người\nđại diện pháp lý của bạn)',
      variable: 'sign',
    },
    {
      title: 'Tên bác sĩ',
      variable: 'applier_contact',
    },
  ];

  return (
    <>
      <RowContainer xs={11.5} sx={{ margin: '20px 0px 30px 0px' }}>
        {labels.map(({ title, variable }, _) => (
          <>
            {Array(2)
              .fill(0)
              .map(() => (
                <RowContent titleRatio={1.2} childrenRatio={2.5} />
              ))}
            {variable === 'date' ? (
              <RowContent
                key={variable}
                title={title}
                titleRatio={1.9}
                childrenRatio={2.4}
              >
                <Form.MuiTextField
                  type="date"
                  required={false}
                  disabled={disabled}
                  {...register(`${variable}`)}
                />
              </RowContent>
            ) : variable === 'name' || variable === 'sign' ? (
              <RowContentPreWrap
                key={variable}
                title={title}
                titleRatio={1.9}
                childrenRatio={2.4}
              >
                <Form.MuiTextField
                  disabled={disabled}
                  required={false}
                  {...register(`${variable}`)}
                />
              </RowContentPreWrap>
            ) : (
              <RowContent
                key={variable}
                title={title}
                titleRatio={1.9}
                childrenRatio={2.4}
              >
                <Form.MuiTextField
                  disabled={disabled}
                  required={false}
                  {...register(`${variable}`)}
                />
              </RowContent>
            )}
          </>
        ))}
      </RowContainer>
    </>
  );
};

export default Signature;
